// routes/WeekelyReportRoutes.js

import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import ExternalWebsite from "../components/Frontend/ExternalWebsite/ExternalWebsite";

export const externalWebsiteRoutes = (
  <Route path="/external_website" element={<MainLayout />}>
    <Route index element={<ExternalWebsite />} />
  </Route>
);
